<!-------------bannner------------>
<div class="banner-part">
  <img src="/assets/images/donate-banner.jpg" alt="" />
  <div class="container">
    <div class="wraper">
      <h1>{{ '::EventList:Title' | abpLocalization }}</h1>
    </div>
  </div>
</div>
<!-------------banner------------>
<!-- ======== Hero Area End ========== -->
<!-- <h1 class="text-center" style="padding: 60px 0 0px 0">Upcoming Mandir Schedule</h1> -->
<div class="container">
  <!-- Display dynamic title based on eventType -->
  <h2 class="text-center" style="margin-top: 20px; margin-bottom: 20px">
    <span *ngIf="eventType === 'major'">{{ '::EventList:MajorFestivalsTitle' | abpLocalization }}</span>
    <span *ngIf="eventType === 'all'">{{ '::EventList:AllEventsTitle' | abpLocalization }}</span>
  </h2>
  
  <!-- Event type filter dropdown -->
  <div class="row mb-4">
    <div class="col-md-6 mx-auto text-center">
      <div class="btn-group" role="group" aria-label="Event Filter">
        <a [routerLink]="['/events/all']" class="btn" [ngClass]="{'btn-primary': eventType === 'all', 'btn-outline-primary': eventType !== 'all'}">
          {{ '::EventList:AllEventsTitle' | abpLocalization }}
        </a>
        <a [routerLink]="['/events/major']" class="btn" [ngClass]="{'btn-primary': eventType === 'major', 'btn-outline-primary': eventType !== 'major'}">
          {{ '::EventList:MajorFestivalsTitle' | abpLocalization }}
        </a>
      </div>
    </div>
  </div>

  <div
    *abpPermission="'Mandir.App.AllowGoogleCalendarSync'"
    class="header-btn text-lg-end d-none d-sm-block ml-lg-4"
  >
    <a (click)="loadGoogleCalendar()" class="btn-circle btn-default btn" role="button"
      ><i class="fa fa-calendar" aria-hidden="true"></i> {{ '::EventList:SyncCalendar' | abpLocalization }}</a
    >
    <a (click)="clearCache('ScheduledEvent')" class="btn-circle btn-default btn" role="button"
      ><i class="fa fa-refresh" aria-hidden="true"></i> {{ '::EventList:ClearCache' | abpLocalization }}</a
    >
  </div>
  <div style="margin-top: 40px; padding: 20px 40px; border: 1px solid black; border-radius: 20px">
    <h2>{{ '::EventList:FestivalDaysTitle' | abpLocalization }}</h2>
    <p style="font-size: 1.5em">
      {{ '::EventList:FestivalDaysExplanation' | abpLocalization }} <br />
      <br />
    </p>
  </div>
  <p-tabView>
    <p-tabPanel header="{{ '::EventList:ListView' | abpLocalization }}">
      <div class="card-grid" *ngIf="items.length">
        <!------->
        <div *ngFor="let item of getEventsByType(eventType)">
          <div class="bot-card" [ngClass]="{'past-event': isPastEvent(item.date)}">
            <div class="image-s">
              <img [src]="item.imageUrl" class="img-fluid" alt="Vaishno" />
            </div>
            <div class="bot-card-ps">
              <div class="Donate-s" style="height: 300px; overflow: hidden">
                <div class="d-flex align-items-center">
                  <i class="fa fa-calendar me-1 primary-color"
                  style="border-radius: 0; margin-right: 20px; margin-bottom: 7px"></i>
                  <span
                    >
                    <h3 *ngIf="!item.id.includes('00000000-0000')">{{ item.date | date : 'MMM dd, yyyy' }}</h3>
                    <h3 *ngIf="item.id.includes('00000000-0000')">{{ item.name }}</h3>
                    </span
                  >
                </div>
                <div
                  class="d-flex align-items-center"
                  style="margin-left: 40px; margin-top: -15px; margin-bottom: 20px"
                  *ngIf="!isAllDayEvent(item.startsAt, item.endsAt)"
                >
                  <span>
                    {{ item.startsAt | date : 'hh:mm a' }} to
                    {{ item.endsAt | date : 'hh:mm a' }}</span
                  >
                </div>
                <h4>{{ item.name }}</h4>
                <p [innerHTML]="item.description"></p>
              </div>

              <div class="button-more small-button-more d-flex justify-content-between">
                <span *ngIf="item.id.includes('00000000-0000')">&nbsp;</span>
                <a *ngIf="!item.id.includes('00000000-0000')" class="btn btn-primary" (click)="showEventDetails(item)" role="button"
                  >{{ '::EventList:Details' | abpLocalization }}</a
                >
                <div *abpPermission="'Mandir.App.AllowGoogleCalendarSync'">
                <a 
                *ngIf="!item.id.includes('00000000-0000')" 
                class="btn btn-primary" 
                (click)="toggleMajorFestival(item)" role="button"
                  >
                  <span *ngIf="!item.isMajorFestival">
                    {{ '::EventList:MarkMajorFestival' | abpLocalization}}
                  </span>
                  <span *ngIf="item.isMajorFestival">
                    {{'::EventList:MarkNotMajorFestival' | abpLocalization}}
                  </span>
                  </a
                >
                </div>
                <a
                  class="btn btn-primary"
                  *ngIf="item.hasSlots"
                  [routerLink]="['/event-slot']"
                  role="button"
                  >{{ '::EventList:JoinQueue' | abpLocalization }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{ '::EventList:CalendarView' | abpLocalization }}">
      <div class="row">
        <h3>{{ '::EventList:Title' | abpLocalization }}</h3>
      </div>
      <iframe 
      src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FToronto&showPrint=0&showCalendars=0&showTz=0&title=Vaishno%20Devi%20Mandir%20Oakville%20-%20Program%20Schedule&src=Y19lYTQ0YmJlYjUyZDZiMTc3YWEzYmJlOGVjNWRlOGU4OWRkMDQ5Y2VkZDg0ODZhZTFmY2UyMTYwNTk0YjVjMzg4QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&src=Y19hZWRiMWE4OWMwZTMzYjFjMmM1YmYyZmM3ZWYyMWY4N2YwZmIyODBjZTQ2ZmFiZGZhZWIxOGJkZDIyMTUxNDdiQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23009688&color=%23d50000"
      style="border:solid 1px #850000" 
      width="100%" 
      height="600" 
      frameborder="0" 
      scrolling="no"></iframe>
    </p-tabPanel>
  </p-tabView>
</div>
